/**
 * @file SignupController
 * @description
 * Load into your application like `myApp.controller('SignupController', require('SignupController.js'))`
 */
module.exports = [
    "$scope",
    "CTHashService",
    "DataService",
    "ChannelRepository",
    "AppConstants",
    "CommitmentModel",
    "$q",
    "CTServiceAPI",
    "CTServiceAPIConfig",
    function($scope, CTHashService, DataService, ChannelRepository, AppConstants, CommitmentModel, $q, CTServiceAPI, CTServiceAPIConfig) {
        const _controller   = this,
              _channel      = ChannelRepository.get(AppConstants.CHANNEL_SUBMISSION.NAME),
              _SMChannel    = ChannelRepository.get(AppConstants.CHANNEL_SOCIALMEDIA.NAME),
              _shareChannel = ChannelRepository.get(AppConstants.CHANNEL_SHARE.NAME),
              STEPS         = {
                  PERSON   : 0,
                  TAGS     : 1,
                  IMAGE    : 2,
                  STATEMENT: 3,
                  FINISH   : 4
              };

        const BEZIRKSSTELLEN_PREFIX = 'Leistungsbereich';

        let _step            = STEPS.PERSON,
            _networkActivity = false;


        _controller.STEPS   = STEPS;
        _controller.getStep = () => _step;

        /**
         * holds the bezirksstellen for the selecty-dropdown (grouped by province)
         * @type {[*]}
         */
        _controller.bezirksstellen = [
            {"city":"Noch nicht aktiv im Roten Kreuz."},    // this item shall not be grouped, so no province exists
            {"province":"Burgenland", "city":"Eisenstadt"},
            {"province":"Burgenland", "city":"Güssing"},
            {"province":"Burgenland", "city":"Jennersdorf"},
            {"province":"Burgenland", "city":"Landesverband Bgld."},
            {"province":"Burgenland", "city":"Mattersburg"},
            {"province":"Burgenland", "city":"Neusiedl am See"},
            {"province":"Burgenland", "city":"Oberpullendorf"},
            {"province":"Burgenland", "city":"Oberwart"},
            {"province":"Kärnten", "city":"Feldkirchen"},
            {"province":"Kärnten", "city":"Hermagor"},
            {"province":"Kärnten", "city":"Klagenfurt"},
            {"province":"Kärnten", "city":"Landesverband Ktn."},
            {"province":"Kärnten", "city":"Spittal/Drau"},
            {"province":"Kärnten", "city":"St. Veit"},
            {"province":"Kärnten", "city":"Villach"},
            {"province":"Kärnten", "city":"Völkermarkt"},
            {"province":"Kärnten", "city":"Wolfsberg"},
            {"province":"Niederösterreich", "city":"Allentsteig"},
            {"province":"Niederösterreich", "city":"Amstetten"},
            {"province":"Niederösterreich", "city":"Atzenbrugg"},
            {"province":"Niederösterreich", "city":"Bad Vöslau"},
            {"province":"Niederösterreich", "city":"Baden"},
            {"province":"Niederösterreich", "city":"Berndorf/St.Veit"},
            {"province":"Niederösterreich", "city":"Bruck an der Leitha"},
            {"province":"Niederösterreich", "city":"Brunn am Gebirge"},
            {"province":"Niederösterreich", "city":"Gänserndorf"},
            {"province":"Niederösterreich", "city":"Gloggnitz"},
            {"province":"Niederösterreich", "city":"Gmünd"},
            {"province":"Niederösterreich", "city":"Götzendorf"},
            {"province":"Niederösterreich", "city":"Gr. Enzersdorf"},
            {"province":"Niederösterreich", "city":"Gr. Weikersdorf"},
            {"province":"Niederösterreich", "city":"Haag"},
            {"province":"Niederösterreich", "city":"Hainburg"},
            {"province":"Niederösterreich", "city":"Hainfeld"},
            {"province":"Niederösterreich", "city":"Herzogenburg"},
            {"province":"Niederösterreich", "city":"Hollabrunn"},
            {"province":"Niederösterreich", "city":"Horn"},
            {"province":"Niederösterreich", "city":"Kirchschlag"},
            {"province":"Niederösterreich", "city":"Klosterneuburg"},
            {"province":"Niederösterreich", "city":"Korneuburg"},
            {"province":"Niederösterreich", "city":"Krems"},
            {"province":"Niederösterreich", "city":"Laa/Thaya"},
            {"province":"Niederösterreich", "city":"Landegg"},
            {"province":"Niederösterreich", "city":"Langenlois"},
            {"province":"Niederösterreich", "city":"Landesverband NÖ"},
            {"province":"Niederösterreich", "city":"Lilienfeld"},
            {"province":"Niederösterreich", "city":"Litschau"},
            {"province":"Niederösterreich", "city":"Marchegg"},
            {"province":"Niederösterreich", "city":"Melk"},
            {"province":"Niederösterreich", "city":"Mistelbach"},
            {"province":"Niederösterreich", "city":"Mödling"},
            {"province":"Niederösterreich", "city":"Neulengbach"},
            {"province":"Niederösterreich", "city":"Neunkirchen"},
            {"province":"Niederösterreich", "city":"Pernitz"},
            {"province":"Niederösterreich", "city":"Pöggstall"},
            {"province":"Niederösterreich", "city":"Purkersdorf"},
            {"province":"Niederösterreich", "city":"Retz"},
            {"province":"Niederösterreich", "city":"Scheibbs"},
            {"province":"Niederösterreich", "city":"Schwechat"},
            {"province":"Niederösterreich", "city":"Sollenau"},
            {"province":"Niederösterreich", "city":"St. Aegyd-NW."},
            {"province":"Niederösterreich", "city":"St. Peter/Au"},
            {"province":"Niederösterreich", "city":"St. Pölten"},
            {"province":"Niederösterreich", "city":"St. Valentin"},
            {"province":"Niederösterreich", "city":"Tulln"},
            {"province":"Niederösterreich", "city":"Waidhofen/Thaya"},
            {"province":"Niederösterreich", "city":"Waidhofen/Ybbs"},
            {"province":"Niederösterreich", "city":"Weitra"},
            {"province":"Niederösterreich", "city":"Wr. Neustadt"},
            {"province":"Niederösterreich", "city":"Ybbs"},
            {"province":"Niederösterreich", "city":"Ziersdorf"},
            {"province":"Niederösterreich", "city":"Zistersdorf"},
            {"province":"Niederösterreich", "city":"Zwettl"},
            {"province":"Oberösterreich", "city":"Blutspendedienst OÖ"},
            {"province":"Oberösterreich", "city":"Braunau"},
            {"province":"Oberösterreich", "city":"Eferding "},
            {"province":"Oberösterreich", "city":"Freistadt "},
            {"province":"Oberösterreich", "city":"Gmunden"},
            {"province":"Oberösterreich", "city":"Grieskirchen"},
            {"province":"Oberösterreich", "city":"Kirchdorf "},
            {"province":"Oberösterreich", "city":"Landesverband OÖ"},
            {"province":"Oberösterreich", "city":"Linz-Land"},
            {"province":"Oberösterreich", "city":"Linz-Stadt"},
            {"province":"Oberösterreich", "city":"Perg"},
            {"province":"Oberösterreich", "city":"Ried im Innkreis"},
            {"province":"Oberösterreich", "city":"Rohrbach"},
            {"province":"Oberösterreich", "city":"Schärding "},
            {"province":"Oberösterreich", "city":"Steyr-Land"},
            {"province":"Oberösterreich", "city":"Steyr-Stadt"},
            {"province":"Oberösterreich", "city":"Urfahr-Umgebung"},
            {"province":"Oberösterreich", "city":"Vöcklabruck "},
            {"province":"Oberösterreich", "city":"Wels-Stadt/Wels-Land"},
            {"province":"Salzburg", "city":"Flachgau"},
            {"province":"Salzburg", "city":"Gastein"},
            {"province":"Salzburg", "city":"Hallein"},
            {"province":"Salzburg", "city":"Lammertal"},
            {"province":"Salzburg", "city":"Landesverband Sbg."},
            {"province":"Salzburg", "city":"Lungau"},
            {"province":"Salzburg", "city":"Radstadt"},
            {"province":"Salzburg", "city":"Salzburg Stadt"},
            {"province":"Salzburg", "city":"St.Johann"},
            {"province":"Salzburg", "city":"Zell am See"},
            {"province":"Steiermark", "city":"Bruck/Kapfenberg"},
            {"province":"Steiermark", "city":"Deutschlandsberg"},
            {"province":"Steiermark", "city":"Feldbach"},
            {"province":"Steiermark", "city":"Fürstenfeld"},
            {"province":"Steiermark", "city":"Graz-Stadt"},
            {"province":"Steiermark", "city":"Graz-Umgebung"},
            {"province":"Steiermark", "city":"Hartberg"},
            {"province":"Steiermark", "city":"Judenburg"},
            {"province":"Steiermark", "city":"Knittelfeld"},
            {"province":"Steiermark", "city":"Landesverband Stmk."},
            {"province":"Steiermark", "city":"Leibnitz"},
            {"province":"Steiermark", "city":"Leoben"},
            {"province":"Steiermark", "city":"Liezen"},
            {"province":"Steiermark", "city":"Murau"},
            {"province":"Steiermark", "city":"Mürzzuschlag"},
            {"province":"Steiermark", "city":"Radkersburg"},
            {"province":"Steiermark", "city":"Voitsberg/Köflach"},
            {"province":"Steiermark", "city":"Weiz"},
            {"province":"Tirol", "city":"Hall"},
            {"province":"Tirol", "city":"Imst"},
            {"province":"Tirol", "city":"Innsbruck"},
            {"province":"Tirol", "city":"Innsbruck-Land"},
            {"province":"Tirol", "city":"Kitzbühel"},
            {"province":"Tirol", "city":"Kufstein"},
            {"province":"Tirol", "city":"Landeck"},
            {"province":"Tirol", "city":"Landesverband Tirol"},
            {"province":"Tirol", "city":"Osttirol"},
            {"province":"Tirol", "city":"Reutte"},
            {"province":"Tirol", "city":"Schwaz"},
            {"province":"Tirol", "city":"Telfs"},
            {"province": "Tirol", "city": "Wattens"},
            {"province":"Vorarlberg", "city":"Bludenz"},
            {"province":"Vorarlberg", "city":"Bregenz"},
            {"province":"Vorarlberg", "city":"Bregenzwald"},
            {"province":"Vorarlberg", "city":"Dornbirn"},
            {"province":"Vorarlberg", "city":"Feldkirch"},
            {"province":"Vorarlberg", "city":"Hohenems"},
            {"province":"Vorarlberg", "city":"KAT Hard"},
            {"province":"Vorarlberg", "city":"KAT Rankweil"},
            {"province":"Vorarlberg", "city":"Landesverband Vbg."},
            {"province":"Vorarlberg", "city":"Lustenau"},
            {"province":"Vorarlberg", "city":"Ortsstelle Andelsbuch"},
            {"province":"Vorarlberg", "city":"Ortsstelle Alberschwende"},
            {"province":"Vorarlberg", "city":"Ortsstelle Götzis"},
            {"province":"Vorarlberg", "city":"Schwarzenberg"},
            {"province":"Vorarlberg", "city":"Wolfurt"},
            {"province":"Wien", "city":"Bezirksstelle Bertha von Suttner"},
            {"province":"Wien", "city":"Bezirksstelle DDr. Lauda"},
            {"province":"Wien", "city":"Bezirksstelle Wien Nord "},
            {"province":"Wien", "city":"Bezirksstelle van Swieten"},
            {"province":"Wien", "city":"Bezirksstellen Wien West "},
            {"province":"Wien", "city":"GS Wien"},
            {"province":"Wien", "city":"Landesverband"}
        ];

        // _controller.selected_bezirksstelle = _controller.bezirksstellen[0].city;

        /**
         * send the current step to the api and proceed to the next step, or directly proceed to the next step, if no data
         * was filled out
         */
        _controller.sendCurrentStep = () => {
            const submit = () => _controller.submit().then((data) => {
                console.log(data, _controller.data);
                _controller.data = {
                    id         : data.id,
                    show_public: true,
                    person     : {
                        name   : data.person.name,
                        surname: data.person.surname,
                        email  : _controller.data.person.email,
                        tags   : data.person.tags
                    },
                    message    : data.message,
                    image_id   : data.image_id,
                    image_url  : data.image_url
                };

                setNextStep();
            });

            // if we arent in the first signup step, send the amend_request param
            if(_controller.getStep() !== STEPS.PERSON)
            {
                _controller.data.amend_request = true;
            }

            // depending on the step, the user can click the 'next' button, but no data is actually sent to the api.
            // this differentiation is performed here
            if(_controller.getStep() == STEPS.IMAGE) {
                // no image set -> just proceed to next step
                if(typeof _controller.data.image_id === 'undefined' || _controller.data.image_id === null) {
                    setNextStep();
                }
                else {
                    _controller.mediaDrop.submitMedia().then(submit);
                }
            }
            else if(_controller.getStep() == STEPS.STATEMENT) {
                // no text given -> just proceed to next step
                if(typeof _controller.data.message === 'undefined' || _controller.data.message === '') {
                    setNextStep();
                }
                else {
                    submit();
                }
            }
            else if(_controller.getStep() == STEPS.TAGS) {
                // if the tags array is empty, just proceed to the next step
                if(typeof _controller.data.person.tags === 'undefined' || _controller.data.person.tags.length == 0) {
                    setNextStep();
                }
                else {
                    submit();
                }
            }
            else {
                submit();
            }
        };

        _controller.skipCurrentStep = () => setNextStep();

        function setNextStep() {
            switch(_controller.getStep()) {
                case STEPS.PERSON:
                    initStep(STEPS.TAGS);
                    break;
                case STEPS.TAGS:
                    initStep(STEPS.IMAGE);
                    break;
                case STEPS.IMAGE:
                    initStep(STEPS.STATEMENT);
                    break;
                case STEPS.STATEMENT:
                    initStep(STEPS.FINISH);
                    break;
            }
        }


        /**
         * Set network activity when flag is defined
         * Get when flag is not defined
         *
         * @param {boolean} [flag]
         */
        _controller.hasNetworkActivity = (flag) => {
            if(flag === true || flag === false) {
                return (_networkActivity = flag);
            }
            else {
                return _networkActivity;
            }
        };


        /**
         * Check if the signup form should be opened
         */
        _controller.isOpen = () => !!CTHashService.get('einsenden');


        /**
         * Reset all data
         */
        _controller.reset = () => {
            _controller.data = {
                show_public: true,
                person     : {}
            };

            _controller.hasFbEmail = false;

            if(_controller.mediaDrop && _controller.mediaDrop.removeMedia) {
                _controller.mediaDrop.removeMedia();
            }

            _step = STEPS.PERSON;

            _channel.notify(AppConstants.CHANNEL_SUBMISSION.ACTION_RESET);
        };

        /**
         * Validation:
         * If the Person has selected an Bezirlsstelle and has a Tag with Prefix BEZIRKSSTELLEN_PREFIX, you can Submit the form
         * @returns {Number|boolean}
         */
        _controller.allowSubmissionByTagsOrBezirksstelle = () => {
            return ((_controller.data.person.tags && _controller.data.person.tags.filter(tag => tag.prefix === BEZIRKSSTELLEN_PREFIX)) || []).length || (_controller.selected_bezirksstelle === _controller.bezirksstellen[0].city);
        };


        /**
         * Displays Tags, if an Bezirksstelle is selected
         * @returns {boolean}
         */
        _controller.showTags = () => {
            return _controller.selected_bezirksstelle && _controller.selected_bezirksstelle !== _controller.bezirksstellen[0].city;
        };

        /**
         * Submit the statement
         */
        _controller.submit = () => {
            // add the custom field 'Bezirksstelle' if it is set
            if(_controller.getStep() == STEPS.TAGS && _controller.selected_bezirksstelle && _controller.selected_bezirksstelle !== '') {
                _controller.data.person.custom_fields = [
                    {
                        'name' : 'Bezirksstelle',
                        'value': _controller.selected_bezirksstelle
                    }
                ];
            }
            let _submit = () => {
                let promise = DataService.submitCommitment(_controller.data, $scope.detail.campaign);
                promise.finally(() => _controller.hasNetworkActivity(false));

                return promise;
            };


            _controller.hasNetworkActivity(true);

            //Reference to mediaDrop is set by the directive
            if(_controller.mediaDrop && _controller.mediaDrop.submitMedia) {
                return _controller.mediaDrop.submitMedia().then(_submit);
            }
            else {
                return _submit();
            }
        };


        /**
         * React on uploading an image
         *
         * @param image_id
         * @param image_url
         */
        _controller.mediaOnUpload = function(image_id, image_url) {
            _controller.data.image_id  = image_id;
            _controller.data.image_url = image_url;
        };

        /**
         * React on removing an images
         */
        _controller.mediaOnRemove = function() {
            delete _controller.data.image_url;
            delete _controller.data.image_id;
        };

        _controller.getShareURL = () => {
            const redirect_url = encodeURIComponent(`${location.protocol}//${location.hostname}${location.pathname}#commitment=${_controller.data.id}`);
            return encodeURIComponent(`${CTServiceAPIConfig.HOST}/api/v1/pages/${AppConstants.PAGE_ID}/commitments/${_controller.data.id}/share?redirect_url=${redirect_url}`);
        };

        /**
         * replace the placeholders %vorname% and %nachname% by the data from the first step.
         *
         * @param text
         * @returns {XML|string}
         */
        _controller.parsePlaceholders = function(text) {
            return text.replace(new RegExp('%vorname%', 'g'), _controller.data.person.name)
                       .replace(new RegExp('%nachname%', 'g'), _controller.data.person.surname);
        };

        function initStep(step) {
            _step = step;

            switch(step) {
                case STEPS.PERSON:
                    break;
                case STEPS.IMAGE:
                    if(_controller.data.image_id) {
                        return setNextStep();
                    }
                    break;
                case STEPS.STATEMENT:
                    if(_controller.data.message) {
                        return setNextStep();
                    }
                    break;
                case STEPS.TAGS:
                    if(!AppConstants.TAGS_ENABLED) {
                        return setNextStep();
                    }
                    break;
            }

        }

        function checkFBData(data, context, itemID) {
            if(context !== 'commitment' && itemID !== 'new') return;

            _controller.hasFbEmail = !!data.email;

            $scope.$applyAsync(() => fetchUserImageFromFacebook().then(() => {
                if(_controller.hasFbEmail && !AppConstants.ZIP_REQUIRED) {
                    $scope.$applyAsync(_controller.sendCurrentStep);
                }
            }));
        }

        /**
         * track a cambuildr action based on the clicked button in the share section
         * @param button
         */
        function trackActionBasedOnClickedButton(button) {

            let _submit = (action) => {
                // if no email is set, the person cant be saved
                if(!_controller.data.person.email)
                    return;

                _controller.data.person.actions = [action];

                let promise                     = DataService.submitCommitment(_controller.data, $scope.detail.campaign);
                promise.finally(() => _controller.hasNetworkActivity(false));

                return promise;
            };

            switch(button) {
                case 'facebook':
                    return _submit({
                        name: 'share',
                        context: 'facebook',
                    });
                case 'facebookMessage':
                    return _submit({
                        name: 'share',
                        context: 'facebookMessage'
                    });
                case 'email':
                    return _submit({
                        name: 'share',
                        context: 'email'
                    });
                case 'to-grassroots':
                    return _submit({
                        name: 'share',
                        context: 'to-grassroots'
                    });
                case 'whatsapp':
                    return _submit({
                        name: 'share',
                        context: 'whatsapp'
                    });
            }
        }

        function fetchUserImageFromFacebook(fb_data) {
            _controller.hasNetworkActivity(true);

            //Create a promise while communication with FB
            return $q((resolve, reject) => {

                //Set the API Call
                FB.api('/me/picture', {
                    width : 1080,
                    height: 1080,
                    fields: 'is_silhouette,url'
                }, (response) => {
                    if(response.data) {
                        resolve(response.data);
                    }
                    else {
                        reject(response);
                    }
                });
            })
                .then((data) => {
                    //If image is no silhouette assign it to the data model
                    if(!data.is_silhouette) {
                        return CTServiceAPI({
                            method: 'POST',
                            url   : '/uploaded_images',
                            params: {
                                url: data.url
                            }
                        }).then((data) => {
                            _controller.data.image_id  = data.image_id;
                            _controller.data.image_url = data.image_url;
                        });
                    }
                })
                .finally(() => _controller.hasNetworkActivity(false));
        }

        (function init() {
            /**
             * Initialize the signup data
             * @type {{person: {}}}
             */
            _controller.reset();


            _SMChannel.subscribe(AppConstants.CHANNEL_SOCIALMEDIA.ACTION_FB_CONNECT, checkFBData);

            _shareChannel.subscribe(AppConstants.CHANNEL_SHARE.ACTION_SHARE, trackActionBasedOnClickedButton);
        }());
    }
];
